<template>
  <div class="subpage course" ref="courseRef" style="background-color: #F7F7F7;">
    <template v-if="$route.path === '/course'">
      <Header v-if="$route.query.platform !== 'mini'" title="课程学习" :is-sub-page="true" ref="navBarRef"></Header>

      <cube-tab-bar
        ref="tabRef"
        v-model="curTab"
        show-slider
        @click="onTabClick"
        class="tab-bar"
      >
        <cube-tab v-for="item in tabs" :key="item.value" :label="item.value">
          {{item.label}}
        </cube-tab>
      </cube-tab-bar>

      <cube-tab-panels v-model="curTab" class="tab-panel">
        <cube-tab-panel :label="0">
          <div class="content" ref="courseContentRef">
            <course-list-panel type-code="1"></course-list-panel> <!-- 课程学习 -->
          </div>
        </cube-tab-panel>
        <cube-tab-panel :label="1">
          <div class="content" ref="guoContentRef">
            <course-list-panel type-code="3"></course-list-panel> <!-- 国学经典  -->
          </div>
        </cube-tab-panel>
        <cube-tab-panel :label="2">
          <div class="content" ref="onlineContentRef">
            <course-list-panel type-code="5"></course-list-panel> <!-- 在线学习  -->
          </div>
        </cube-tab-panel>
      </cube-tab-panels>
    </template>

    <router-view/>
  </div>
</template>

<script>
import Header from '../../components/Header'
import CourseListPanel from '@/views/course/components/tabPanels/CourseListPanel'

export default {
  name: 'Course',
  components: {
    Header,
    CourseListPanel
  },
  data () {
    return {
      curTab: 0,
      tabs: [{
        value: 0,
        label: '课程学习'
      },
      {
        value: 1,
        label: '国学经典'
      },
      {
        value: 2,
        label: '在线学习'
      }]
    }
  },
  mounted () {
    if (this.$route.query && this.$route.query.token) {
      this.$store.commit('setInfo', { token: this.$route.query.token })
    }

    if (this.$route.path === '/course') {
      this.$nextTick(() => {
        const navBarHeight = this.$refs.navBarRef ? this.$refs.navBarRef.$el.clientHeight : 0
        this.$refs.courseContentRef.style.height = this.$refs.guoContentRef.style.height = this.$refs.onlineContentRef.style.height =
          (this.$refs.courseRef.clientHeight - navBarHeight - this.$refs.tabRef.$el.scrollHeight) + 'px'
      })
    }
  },
  methods: {
    onTabClick (value) {
      console.log(value)
    }
  }
}
</script>

<style lang="stylus">
body
  background-color #f7f7f7 !important
.course
  .tab-bar
    height 40px
    background-color #fff
    .cube-tab-bar-slider
      width 15% !important
      left 9.167% !important
      bottom 8px !important
</style>
